var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFuelConsumptionInact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "#D1D5DB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9129_27200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6654 19.332C22.6654 19.7741 22.4898 20.198 22.1772 20.5105C21.8646 20.8231 21.4407 20.9987 20.9987 20.9987C20.5567 20.9987 20.1327 20.8231 19.8202 20.5105C19.5076 20.198 19.332 19.7741 19.332 19.332V18.7765C19.332 18.6291 19.2735 18.4878 19.1693 18.3836C19.0651 18.2795 18.9238 18.2209 18.7765 18.2209H18.2209V19.8876C18.22 20.624 17.9271 21.3301 17.4064 21.8508C16.8856 22.3715 16.1796 22.6645 15.4431 22.6654H12.1098C11.3734 22.6645 10.6673 22.3715 10.1466 21.8508C9.62585 21.3301 9.33291 20.624 9.33203 19.8876V15.4431H18.2209V17.1098H18.7765C19.2185 17.1098 19.6424 17.2854 19.955 17.598C20.2675 17.9105 20.4431 18.3344 20.4431 18.7765V19.332C20.4431 19.4794 20.5017 19.6207 20.6059 19.7249C20.71 19.8291 20.8514 19.8876 20.9987 19.8876C21.146 19.8876 21.2873 19.8291 21.3915 19.7249C21.4957 19.6207 21.5543 19.4794 21.5543 19.332V13.7765C21.2596 13.7765 20.977 13.6594 20.7686 13.451C20.5602 13.2427 20.4431 12.96 20.4431 12.6654V11.2287L19.4948 10.2804C19.3936 10.1756 19.3376 10.0353 19.3389 9.88959C19.3401 9.74392 19.3986 9.60458 19.5016 9.50158C19.6046 9.39857 19.7439 9.34014 19.8896 9.33888C20.0353 9.33761 20.1756 9.39361 20.2804 9.49481L21.6893 10.9031C22.3037 11.5142 22.6541 12.3417 22.6654 13.2081C22.6654 13.2126 22.6654 19.332 22.6654 19.332ZM18.2209 12.1098C18.22 11.3734 17.9271 10.6673 17.4064 10.1466C16.8856 9.62585 16.1796 9.33291 15.4431 9.33203H12.1098C11.3734 9.33291 10.6673 9.62585 10.1466 10.1466C9.62585 10.6673 9.33291 11.3734 9.33203 12.1098L9.33203 14.332H18.2209V12.1098Z",
    fill: "#D1D5DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9129_27200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 13.3333,
    fill: "white",
    transform: "translate(9.33203 9.33203)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelConsumptionInact);
export default __webpack_public_path__ + "static/media/fuelConsumptionInact.cd1c5d3170b4ac55590cb61d57c10778.svg";
export { ForwardRef as ReactComponent };